import {Component, Input, Output, EventEmitter} from "@angular/core"
import {PromptEventService} from "../../services/prompt-event.service"

@Component({
  selector: "app-suggested-prompt",
  templateUrl: "./suggested-prompt.component.html",
})
export class SuggestedPromptComponent {
  @Input() text = ""
  @Input() accentColor = "#FF6D03"
  @Input() disabledColor = "#FFA101"
  @Output() onClick = new EventEmitter<void>()

  buttonStyle = {
    borderColor: this.accentColor,
    color: this.accentColor,
    backgroundColor: "transparent",
  }

  constructor(private promptEventService: PromptEventService) {}

  ngOnInit() {
    this.updateButtonStyle()
  }

  ngOnChanges() {
    this.updateButtonStyle()
  }

  updateButtonStyle() {
    this.buttonStyle = {
      borderColor: this.accentColor,
      color: this.accentColor,
      backgroundColor: "transparent",
    }
  }

  onMouseOver() {
    this.buttonStyle = {
      borderColor: this.accentColor,
      color: "white",
      backgroundColor: this.accentColor,
    }
  }

  onMouseOut() {
    this.buttonStyle = {
      borderColor: this.accentColor,
      color: this.accentColor,
      backgroundColor: "transparent",
    }
  }

  handleClick() {
    // Emit the event for direct parent components
    this.onClick.emit()

    // Also emit through the service for global subscribers
    this.promptEventService.emitPromptClicked(this.text)
  }
}
